import React from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";

const LoaderTitle = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px 50px;
  gap: 16px;
  align-items: center;
`;

const LoaderCards = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  overflow: hidden;
`;

const PastClassesBlockLoader = () => {
  return (
    <>
      <LoaderTitle>
        <Skeleton height={30} />
        <Skeleton height={50} width={50} circle />
        <Skeleton height={50} width={50} circle />
      </LoaderTitle>
      <br />
      <LoaderCards>
        {" "}
        <Skeleton height={270} width={420} />
        <Skeleton height={270} width={420} />
        <Skeleton height={270} width={420} />
        <Skeleton height={270} width={420} />
      </LoaderCards>
    </>
  );
};

export { PastClassesBlockLoader };
